<template>
  <div>
    
    <!-- Cards -->
    <div class="small-cards">
      <div class="container">
        <div class="row">
          <div v-if="row.image7" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image7" class="img-fluid" :alt="row.title7" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title7"
                      :style="'color:'+row.color7+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content7"
                      :style="'color:'+row.contentColor7+' !important'">
                  </div>
                  <router-link v-if="row.button7" :to="row.redirect7"
                      class="btn-line btn-line-gray">{{ row.button7 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-if="row.image8" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image8" class="img-fluid" :alt="row.title8" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title8"
                      :style="'color:'+row.color8+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content8"
                      :style="'color:'+row.contentColor8+' !important'">
                  </div>
                  <router-link v-if="row.button8" :to="row.redirect8"
                      class="btn-line btn-line-gray">{{ row.button8 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-if="row.image9" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image9" class="img-fluid" :alt="row.title9" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title9"
                      :style="'color:'+row.color9+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content9"
                      :style="'color:'+row.contentColor9+' !important'">
                  </div>
                  <router-link v-if="row.button9" :to="row.redirect9"
                      class="btn-line btn-line-gray">{{ row.button9 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-if="row.image10" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image10" class="img-fluid" :alt="row.title10" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title10"
                      :style="'color:'+row.color10+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content10"
                      :style="'color:'+row.contentColor10+' !important'">
                  </div>
                  <router-link v-if="row.button10" :to="row.redirect10"
                      class="btn-line btn-line-gray">{{ row.button10 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-if="row.image11" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image11" class="img-fluid" :alt="row.title11" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title11"
                      :style="'color:'+row.color11+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content11"
                      :style="'color:'+row.contentColor11+' !important'">
                  </div>
                  <router-link v-if="row.button11" :to="row.redirect11"
                      class="btn-line btn-line-gray">{{ row.button11 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

           <div v-if="row.image12" class="col-lg-4 col-sm-6">
            <div class="small-card d-flex justify-content-between">
              <img :src="row.image12" class="img-fluid" :alt="row.title12" />
              <div class="card-details d-flex flex-wrap align-items-center">
                <div>
                  <div class="title mb-2"
                      v-html="row.title12"
                      :style="'color:'+row.color12+' !important'"> 
                  </div>
                  <div class="text gray-color"
                      v-html="row.content12"
                      :style="'color:'+row.contentColor12+' !important'">
                  </div>
                  <router-link v-if="row.button12" :to="row.redirect12"
                      class="btn-line btn-line-gray">{{ row.button12 }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Cards -->

  </div>
</template>

<script>
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
